module.exports = __webpack_public_path__ + "img/connected.8b3476b0.svg";